// Copyright 2026 AllSpice. All rights reserved. Not Gitea.
// SPDX-License-Identifier: UNLICENSED

import {hideElem, showElem} from '../utils/dom.ts';
import {setFileFolding} from './file-fold.ts';

// Unfold whatever hides a code comment (an outdated or resolved conversation,
// a folded file) so a link to it lands on the comment rather than on nothing.
export function revealCodeComment(commentDiv: Element): void {
  const groupID = commentDiv.closest('div[id^="code-comments-"]')?.getAttribute('id');
  if (!groupID?.startsWith('code-comments-')) return;
  const id = groupID.slice('code-comments-'.length);
  hideElem(`#show-outdated-${id}`);
  showElem(`#code-comments-${id}, #code-preview-${id}, #hide-outdated-${id}`);
  const ancestorDiffBox = commentDiv.closest<HTMLElement>('.diff-file-box');
  if (ancestorDiffBox?.getAttribute('data-folded') === 'true') {
    setFileFolding(ancestorDiffBox, ancestorDiffBox.querySelector('.fold-file'), false);
  }
}
